import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import {
  MixedSchema,
  getSchemaText,
  isMixedSchema,
} from '@principle-theorem/editor';
import { getSmsSegmentCount, sanitiseSmsBody } from '@principle-theorem/shared';
import { ReplaySubject, type Observable } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { NgCommonModule } from '../ng-common.module';
import { type TypedFormControl } from '../forms/typed-form-group';

@Component({
  selector: 'pt-sms-segment-counter',
  templateUrl: './sms-segment-counter.component.html',
  styleUrls: ['./sms-segment-counter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NgCommonModule],
})
export class SmsSegmentCounterComponent {
  formCtrl$ = new ReplaySubject<TypedFormControl<string | MixedSchema>>(1);
  segmentCount$: Observable<number>;

  @Input()
  set formCtrl(formCtrl: TypedFormControl<string | MixedSchema>) {
    if (formCtrl) {
      this.formCtrl$.next(formCtrl);
    }
  }

  constructor() {
    this.segmentCount$ = this.formCtrl$.pipe(
      switchMap((formCtrl) =>
        formCtrl.valueChanges.pipe(startWith(formCtrl.value))
      ),
      map((value) => {
        const plainText = isMixedSchema(value)
          ? getSchemaText(value)
          : String(value ?? '');
        return sanitiseSmsBody(plainText);
      }),
      map((sanitisedText) => getSmsSegmentCount(sanitisedText)),
      startWith(0)
    );
  }
}
